import {
  Button,
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Stack } from "@mui/material";
import DateField from "components/CustomFields/DateField";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { getCurrentDate } from "utils/dateGetters.js";
import { dbGet } from "utils/DBFetchers";

import useStyles from "./styles";

const BURNABLE_AUDITS_DOCUMENTATION_LINK = "https://cfr-config.s3.sa-east-1.amazonaws.com/cfr_rules_documentation/panel_de_control_auditoria_quemables.pdf";
const FIRST_MONTH = new Date(getCurrentDate().getFullYear(), 0, 1);


const LAST_MONTH = new Date(
  getCurrentDate().getFullYear(),
  getCurrentDate().getMonth(),
  1,
);

const getDateFormatted = (date) => {
  return format(date, "yyyy/MM");
};

const FILTERS = {
  fromDate: getCurrentDate(),
  toDate: getCurrentDate(),
  program: null,
  distributor: null,
  brand: null,
  presentation: null,
  bussinessArea: null,
};

const SELECT_INFORMATION = {
  programs: [],
  distributors: [],
  bussinessAreas: [],
  brands: [],
  presentations: [],
};

export const AuditBurnableSelectionForm = (props) => {
  var classes = useStyles();

  const [filters, setFilters] = useState(FILTERS);
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();
  const [selectInformation, setSelectInformation] =
    useState(SELECT_INFORMATION);

  const handleFilterChange = (filter, value) => {
    setFilters({
      ...filters,
      [filter]: value,
    });
  };

  const handleFromPeriodChange = (date) => {
    var dateOnFirstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    if (dateOnFirstDay > filters.toDate) {
      snackbarOpen("error", "El período final no puede ser menor al inicial");
      return;
    }
    setFilters({
      ...filters,
      fromDate: dateOnFirstDay,
    });
  };

  const handleToPeriodChange = (date) => {
    var dateOnFirstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    if (dateOnFirstDay < filters.fromDate) {
      snackbarOpen("error", "El período final no puede ser menor al inicial");
      return;
    }
    setFilters({
      ...filters,
      toDate: dateOnFirstDay,
    });
  };

  const handleDistributorChange = (event, newValue) => {
    let newValueIds = [];
    if (newValue) {
      newValueIds = newValue.map((distributor) => distributor.id);
    }
    handleFilterChange("distributor", newValue ? newValueIds : newValue);
  };

  const handleBussinessAreaChange = (event, newValue) => {
    handleFilterChange("businessArea", newValue);
  };

  const handleBrandChange = (event, newValue) => {
    handleFilterChange("brand", newValue);
  };

  const handlePresentationChange = (event, newValue) => {
    handleFilterChange("presentation", newValue);
  };

  const getFiltersContent = () => {
    Promise.all([
      dbGet("distributors"),
      dbGet("presentations/bussiness_areas"),
      dbGet("presentations/brands"),
      dbGet("presentations"),
    ])
      .then(
        ([
          distributors,
          bussinessAreas,
          brands,
          presentations,
        ]) => {
          setSelectInformation({
            distributors,
            bussinessAreas,
            brands,
            presentations,
          });
        },
      )
      .catch((error) => {
        snackbarOpen("error", "Error al obtener los datos");
      });
  };

  const checkRequiredParams = (onApplyFiltersFunc) => {
    onApplyFiltersFunc(filters);  // no mandatory fields to check
  };

  useEffect(() => {
    getFiltersContent();
  }, []);

  return (
    <>
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <Grid
        item
        xs={12}
        lg={12}
        style={{ marginBottom: "10px", marginLeft: "2.5%" }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          <Typography variant="h4" className={classes.alignedText}>
            Selección
          </Typography>
          <Button
            component="a"
            href={BURNABLE_AUDITS_DOCUMENTATION_LINK}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            variant="text"
          >
            Ver Documentación
          </Button>
        </Grid>
        <Divider />
      </Grid>

      <Grid container justifyContent="center" spacing={1}>
        {/* Fila 1 */}
        <Grid item container xs={12} justifyContent="center">
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography className={classes.alignedText} weight="bold">
                Período inicial
              </Typography>
            </Grid>
            <Grid item xs={9} className={classes.alignLeft}>
              <DateField
                views={["year", "month"]}
                minDate={new Date("2013-10-01")}
                maxDate={getCurrentDate()}
                format={"MM/yyyy"}
                value={filters.fromDate}
                onChange={handleFromPeriodChange}
                fieldClassName={classes.dateSelectionField}
              />
            </Grid>
          </Grid>

          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography className={classes.alignedText} weight="bold">
                Período final
              </Typography>
            </Grid>
            <Grid item xs={9} className={classes.alignLeft}>
              <DateField
                views={["year", "month"]}
                minDate={new Date("2013-10-01")}
                maxDate={getCurrentDate()}
                format={"MM/yyyy"}
                value={filters.toDate}
                onChange={handleToPeriodChange}
                fieldClassName={classes.dateSelectionField}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Fila 2 */}
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
          style={{ marginTop: "5px" }}
        >
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography
                className={classes.alignedTextWithPadding}
                weight="bold"
              >
                Cadena
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.alignLeft}>
              <Autocomplete
                multiple
                className={classes.simpleSecondColumnSelectionField}
                id="distributor"
                autoHighlight
                onChange={handleDistributorChange}
                options={selectInformation.distributors || []}
                getOptionLabel={(option) => option.name}
                sx={{ width: 700 }}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione" />
                )}
              />
            </Grid>
          </Grid>

          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography
                className={classes.alignedTextWithPadding}
                weight="bold"
              >
                Marca
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.alignLeft}>
              <Autocomplete
                className={classes.simpleSecondColumnSelectionField}
                id="brand"
                autoHighlight
                onChange={handleBrandChange}
                options={selectInformation.brands || []}
                getOptionLabel={(option) => option}
                sx={{ width: 700 }}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione" />
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Fila 3 */}
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
          style={{ marginTop: "5px" }}
        >
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography
                className={classes.alignedTextWithPadding}
                weight="bold"
              >
                Presentación
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.alignLeft}>
              <Autocomplete
                className={classes.simpleSecondColumnSelectionField}
                id="presentation"
                autoHighlight
                onChange={handlePresentationChange}
                options={selectInformation.presentations || []}
                getOptionLabel={(option) => option.name}
                sx={{ width: 700 }}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione" />
                )}
              />
            </Grid>
          </Grid>
          
          <Grid item container xs={4}>
            <Grid item xs={3} className={classes.alignRight}>
              <Typography
                className={classes.alignedTextWithPadding}
                weight="bold"
              >
                Área de negocio
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.alignLeft}>
              <Autocomplete
                className={classes.simpleSecondColumnSelectionField}
                id="bussinessArea"
                autoHighlight
                onChange={handleBussinessAreaChange}
                options={selectInformation.bussinessAreas || []}
                getOptionLabel={(option) => option}
                sx={{ width: 700 }}
                renderInput={(params) => (
                  <TextField {...params} label="Seleccione" />
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          style={{ marginTop: "20px", marginBottom: "10px" }}
          spacing={2}
          className={classes.uploadButton}
        >
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                // props.onApplyFilters(filters);
                checkRequiredParams(props.onApplyFilters);
              }}
            >
              Aplicar
            </Button>
            {/* To be implemented when needed 
            <Button
              disabled={props.isLoading || props.isInitialState}
              variant="contained"
              color="secondary"
              onClick={props.exportFunction}
            >
              Exportar
            </Button> 
            */}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};
